import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

let childRouters = [];
// 向下查找所有router.js
(module => module.keys().forEach((key) => {
	childRouters = childRouters.concat(module(key).default);
}))(require.context('@/components/page/', true, /router\.js$/));

export default new Router({
	routes: [{
			path: '/',
			redirect: '/dashboard'
		},
		{
			path: '/',
			component: () => import('../components/common/Home.vue'),
			meta: {
				title: '自述文件'
			},
			children: childRouters

			/*[
                {
                    path: '/dashboard',
                    component: () => import('../components/page/Dashboard.vue'),
                    meta: { title: '系统首页' }
                },
                {
                    path: '/icon',
                    component: () => import('../components/page/Icon.vue'),
                    meta: { title: '自定义图标' }
                },
                {
                    path: '/vipCustom',
                    component: () => import('../components/page/vipCustom.vue'),
                    meta: { title: '大客户管理' }
                },
                {
                    path: '/tabs',
                    component: () => import('../components/page/Tabs.vue'),
                    meta: { title: 'tab选项卡' }
                },
                {
                    path: '/form',
                    component: () => import('../components/page/BaseForm.vue'),
                    meta: { title: '基本表单' }
                },
                {
                    // 富文本编辑器组件
                    path: '/editor',
                    component: () => import('../components/page/VueEditor.vue'),
                    meta: { title: '富文本编辑器' }
                },
                {
                    // markdown组件
                    path: '/markdown',
                    component: () => import('../components/page/Markdown.vue'),
                    meta: { title: 'markdown编辑器' }
                },
                {
                    // 图片上传组件
                    path: '/upload',
                    component: () => import('../components/page/Upload.vue'),
                    meta: { title: '文件上传' }
                },
                {
                    // vue-schart组件
                    path: '/charts',
                    component: () => import('../components/page/BaseCharts.vue'),
                    meta: { title: 'schart图表' }
                },
                {
                    // 拖拽列表组件
                    path: '/drag',
                    component: () => import('../components/page/DragList.vue'),
                    meta: { title: '拖拽列表' }
                },
                {
                    // 拖拽Dialog组件
                    path: '/dialog',
                    component: () => import('../components/page/DragDialog.vue'),
                    meta: { title: '拖拽弹框' }
                },
                //在这加页面
                {
                    path: '/customPeople/:customName',
                    component: () => import('../components/page/CustomPeople.vue'),
                    meta: { title: '商户人员' }
                },
                {
                    path: '/airportCustom/:customName',
                    component: () => import('../components/page/AirportCustom.vue'),
                    meta: { title: '航空政策码' }
                },
                {
                    path: '/memberInfo',
                    component: () => import('../components/page/MemberInfo.vue'),
                    meta: { title: '会员资料管理' }
                },
                {
                    path: '/memberRule/:VipLevel/:VipID',
                    component: () => import('../components/page/MemberRule.vue'),
                    meta: { title: '会员规则管理' }
                },{
                    path: '/memberPro',
                    component: () => import('../components/page/MemberPro.vue'),
                    meta: { title: '会员产品管理' }
                },{
                    path: '/carReport',
                    component: () => import('../components/page/CarReport.vue'),
                    meta: { title: '车票对数报表' }
                },{
                    path: '/appointReport',
                    component: () => import('../components/page/AppointReport.vue'),
                    meta: { title: '约车对数报表' }
                },{
                    path: '/carEarningReport',
                    component: () => import('../components/page/CarEarningReport.vue'),
                    meta: { title: '司机对数报表' }
                },{
                    path: '/driverReport',
                    component: () => import('../components/page/DriverReport.vue'),
                    meta: { title: '接送车收入报表' }
                },{
                    path: '/flightCallback',
                    component: () => import('../components/page/FlightCallback.vue'),
                    meta: { title: '机票回访' }
                },{
                    path: '/appointCallback',
                    component: () => import('../components/page/AppointCallback.vue'),
                    meta: { title: '预约回访' }
                },{
                    path: '/flghtOrder',
                    component: () => import('../components/page/FlghtOrder.vue'),
                    meta: { title: '机票订单' }
                },{
                    path: '/followCallback',
                    component: () => import('../components/page/FollowCallback.vue'),
                    meta: { title: '跟进回访' }
                },
            ]*/
		},
		{
			path: '/404',
			name: '404',
			component: () => import('../components/page/404.vue'),
			meta: {
				title: '404'
			}
		},
		{
			path: '/login',
			name: 'login',
			component: () => import('../components/page/Login.vue'),
			meta: {
				title: 'YUSTAR系统登陆'
			}
		},
		{
			path: '/supplier_form/:code',
			name: 'supplier_form',
			component: () => import('../components/page/SupplierForm.vue'),
			meta: {
				title: 'Supplier Data Form'
			}
		}
	],
	mode: "history",
	// base:"/OA"
});


// WEBPACK FOOTER //
// ./src/router/index.js